import { render } from "./TermosPolitica.vue?vue&type=template&id=c1aea8ce&scoped=true"
const script = {}

import "./TermosPolitica.vue?vue&type=style&index=0&id=c1aea8ce&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1aea8ce"]])

export default __exports__